<template>
<div class="chapter">
<div class="inner_page">
<p class="p6"><span class="sz">WITH THIS RING</span></p>
<p class="p7"><span class="sz"><b>Reviews &amp; Accolades</b></span></p>
<div style="text-align:center"><img alt="flourish" src="images/flourish.png"/></div>
<p class="p8"><span class="sz">"Fast and funny... you won't be able to put down this humorous whodunit."</span></p>
<p class="p3"><span class="sz">~<i>Alice Duncan, author of Daisy Gumm Majesty, Mercy Allcutt and Annabelle Blue mysteries</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section3.vue?18e6b97e